var render = function render(){var _vm=this,_c=_vm._self._c;return _c('zpa-row',{attrs:{"height":"auto"}},[_c('Button',{staticClass:"btn",attrs:{"disabled":_vm.disabled,"icon":_vm.icon}},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }